import React from "react"
import { Wrapper } from "./style"
import BusImg from "../../../assets/images/alquiler/bus.webp"
import ModeloIcon from "../../../assets/images/alquiler/modelo.svg"
import GamaIcon from "../../../assets/images/alquiler/gama.svg"
import PasajerosIcon from "../../../assets/images/alquiler/pasajeros.svg"
import PlacaIcon from "../../../assets/images/alquiler/placa.svg"

const buses = [
  {
    img: BusImg,
    title: "Bus/Minibus",
    specs: [
      { icon: ModeloIcon, top: "Modelo", bottom: "Of-1724" },
      { icon: PlacaIcon, top: "Placa", bottom: "BVI -124" },
      { icon: PasajerosIcon, top: "50", bottom: "pasajeros" },
      { icon: GamaIcon, top: "Gama", bottom: "platinium" },
    ],
  },
  {
    img: BusImg,
    title: "Custer",
    specs: [
      { icon: ModeloIcon, top: "Modelo", bottom: "Of-1724" },
      { icon: PlacaIcon, top: "Placa", bottom: "BVI -124" },
      { icon: PasajerosIcon, top: "50", bottom: "pasajeros" },
      { icon: GamaIcon, top: "Gama", bottom: "platinium" },
    ],
  },
  {
    img: BusImg,
    title: "Van",
    specs: [
      { icon: ModeloIcon, top: "Modelo", bottom: "Of-1724" },
      { icon: PlacaIcon, top: "Placa", bottom: "BVI -124" },
      { icon: PasajerosIcon, top: "50", bottom: "pasajeros" },
      { icon: GamaIcon, top: "Gama", bottom: "platinium" },
    ],
  },
]

const Flota = () => (
  <Wrapper>
    <div className="header" data-aos="fade-up" data-aos-duration="1000">
      <h2>Nuestra Flota</h2>
      <p>Encuentra el auto perfecto para tu viaje</p>
    </div>
    <div className="grid container">
      {buses.map((bus, key) => (
        <div className="card" key={key} data-aos="fade-up" data-aos-duration="1000" data-aos-delay={key * 200}>
          <img className="card__img" src={bus.img} alt={bus.title} />
          <h3>{bus.title}</h3>
          <div className="card__specs">
            {bus.specs.map((spec, i) => (
              <div className="spec" key={i}>
                <img src={spec.icon} alt={spec.top} />
                <span>{spec.top}</span>
                <span>{spec.bottom}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </Wrapper>
)

export default Flota
